let validators_messages = {
  fieldIsRequired: "To pole jest wymagane.",
  invalidFormat: "Niepoprawny format.",

  numberTooSmall: "The number is too small! Minimum: {0}",
  numberTooBig: "The number is too big! Maximum: {0}",
  invalidNumber: "To pole jest wymagane.",
  invalidInteger: "Wartość nie jest liczbą",

  textTooSmall: "The length of text is too small! Current: {0}, Minimum: {1}",
  textTooBig: "The length of text is too big! Current: {0}, Maximum: {1}",
  thisNotText: "This is not a text!",

  thisNotArray: "This is not an array!",

  selectMinItems: "Select minimum {0} items!",
  selectMaxItems: "Select maximum {0} items!",

  invalidDate: "Niepoprawna data!",
  dateIsEarly: "The date is too early! Current: {0}, Minimum: {1}",
  dateIsLate: "The date is too late! Current: {0}, Maximum: {1}",

  invalidEmail: "To nie jest poprawny adres email.",
  invalidURL: "Invalid URL!",

  invalidCard: "Invalid card format!",
  invalidCardNumber: "Invalid card number!",

  invalidTextContainNumber:
    "Invalid text! Cannot contains numbers or special characters",
  invalidTextContainSpec: "Invalid text! Cannot contains special characters"
};

export function get_validator_messages() {
  return validators_messages;
}
